import { TextInput } from '@frontend/basic-forms';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

interface AsyncSearchProps {
    id?: string;
    filterValue?: (value: string) => void;
    value?: string | null;
    placeholder?: string;
    label?: React.ReactNode | null;
    resetFilter?: boolean;
    className?: string;
}

export const Filter = (props: AsyncSearchProps) => {
    const intl = useIntl();
    const [filterValue, changeFilterValue] = useState<string | null>(props.value ?? null);

    useEffect(() => {
        if (props.resetFilter) {
            changeFilterValue('');
        }
    }, [props.resetFilter]);

    useEffect(() => {
        changeFilterValue(props.value ?? null);
    }, [props.value]);

    useEffect(() => {
        if (filterValue === null) return;
        const timeOutId = setTimeout(() => filter(filterValue), 300);
        return () => clearTimeout(timeOutId);
    }, [filterValue]);

    const filter = async (value: string) => {
        props.filterValue && props.filterValue(value);
    };

    return (
        <TextInput
            className={props.className}
            id={props.id ? props.id : 'Search'}
            label={
                props.label !== undefined
                    ? props.label
                    : intl.formatMessage({ defaultMessage: 'Search', id: 'common.search', description: 'Search placeholder' })
            }
            placeholder={
                props.placeholder ? props.placeholder : intl.formatMessage({ defaultMessage: 'Search', id: 'common.search', description: 'Search placeholder' })
            }
            value={filterValue}
            useConditionedStyling={false}
            onChange={changeFilterValue}
            submitted={false}
        />
    );
};
